<app-summary-top [header]="header" [mobile]="true" [showSave]="false"></app-summary-top>
<app-base-form [fields]="fields" [focusFieldIndex]="0" #viewStockForm></app-base-form>
@if (model$ | async; as model) {
  <app-readonly-grid
    gridCssClass="scanner-grid"
    [sizeToFit]="true"
    [stateKey]="header"
    [columnDefs]="columnDefs"
    [rowData]="model"
  ></app-readonly-grid>
}
